import api from "app/api";
import store from "app/store";

const getPrimaryEventById = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: "PRIMARY_EVENT_DATA:SET", data });

    if (callback) callback(data);
  };

  const url = `/events/${id}`

  await api.get(url, {
    id: "get-primary-event-by-id",
    success: {
      callback: successCallback,
    },
    failure: {
      callback: () => callback({ failure: true }),
    },
    params: {
      buyerFlow: true,
    },
  });
};

const getImageById = async (id, callback = () => {}) => {
  const url = `/image/${id}`;

  try {
    const response = await api.get(url, {
      responseType: "arraybuffer",
    });

    // Convert the binary data to a base64 string
    const base64String = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), "")
    );

    const imageBase64 = `data:image/jpeg;base64,${base64String}`; // Adjust the MIME type if needed

    // Call the success callback with the base64 image
    if (callback) callback(imageBase64);

    // Return the base64 image
    return imageBase64;
  } catch (error) {
      callback({ failure: true });
    return null;
  }
};

const createBookings = async (payload, callback, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'BOOKING_DATA:SET', data: data?.booking });

    if (data?.user) {
      store.dispatch({ type: 'APP:USER_DATA:SET', data: data.user });
    }

    if (data?.tokens) {
      store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data.tokens, refresh: true });
    }

    if (callback) callback(data);
  };

  await api.post("/bookings",
    payload, 
    {
      id: "book-tickets",
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
        callback: failureCb,
      },
    });
};

const createBookingSession = async (payload, callback, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'TEMPORARY:BOOKING_DATA:SET', data: data?.booking });

    if (data?.user) {
      store.dispatch({ type: 'APP:USER_DATA:SET', data: data.user });
    }

    if (data?.tokens) {
      store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data.tokens, refresh: true });
    }

    if (callback) callback(data);
  };

  await api.post("/bookings",
    payload, 
    {
      id: "book-tickets",
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
        callback: failureCb,
      },
    });
};

const completeBookingSession = async (id, payload, callback, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'BOOKING_DATA:SET', data });

    if (data?.user) {
      store.dispatch({ type: 'APP:USER_DATA:SET', data: data.user });
    }

    if (data?.tokens) {
      store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data.tokens, refresh: true });
    }

    if (callback) callback(data);
  };

  await api.put(`/bookings/${id}`,
    payload, 
    {
      id: "book-tickets-completion",
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
        callback: failureCb,
      },
      keepalive: true,
    });
};

const cancelBookingSession = async (id, callback, failureCb) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'BOOKING_DATA:SET', data: data?.booking });

    if (data?.user) {
      store.dispatch({ type: 'APP:USER_DATA:SET', data: data.user });
    }

    if (data?.tokens) {
      store.dispatch({ type: 'APP:SET_JWT_TOKEN', data: data.tokens, refresh: true });
    }

    if (callback) callback(data);
  };

  const bookingData = await api.get(`/bookings/${id}`);

  if (bookingData?.data?.data?.payment_status === 'PENDING') {
    await api.delete(`/bookings/${id}`,
      {
        id: "cancel-booking",
        success: {
          callback: successCallback,
        },
        failure: {
          showNotifier: true,
          callback: failureCb,
        },
      });
  }
};

const getPriceBreakup = async ({ id, ticketId, state, count }, callback) => {
  await api.post(`/bookings/invoices`,
    {
      state,
      items: [{
        event_id: id,
        event_slab_id: ticketId,
        quantity: count,
      }],
    },
    {
      id: "get-price-breakup",
      success: {
        callback,
      },
      failure: {
        callback: () => callback({ failure: true }),
      },
    },
  );
};

export {
    getPrimaryEventById,
    createBookings,
    getImageById,
    createBookingSession,
    completeBookingSession,
    cancelBookingSession,
    getPriceBreakup,
}